import EcoSpace from 'eco-design/base/eco-space';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import AccessoriesA from './components/AccessoriesA';
import Animation3D from './components/Animation3D';
import Animation1 from './components/Animation1';
import BannerA from './components/BannerA';
import BannerB from './components/BannerB';
import BlackA from './components/BlackA';
import ListA2 from './components/ListA2';
import CompareA from './components/CompareA';
import FaqA from './components/FaqA';
import FooterTcA from './components/FooterTcA';
import ListA1 from './components/ListA1';
import ListB from './components/ListB';
import PageNavLeft, { Theme } from './components/PageNavLeft';
import SectionA2 from './components/SectionA2';
import SectionB from './components/SectionB';
import SectionC from './components/SectionC';
import SectionD from './components/SectionD';
// import UserListA from './components/UserListA';
import WhatInBoxA from './components/WhatInBoxA';
import { useLang } from '@/i18n';

export default function EU_Product() {
    const { t } = useLang('theProduct.KSP');
    const { pageStatus } = useProductStore();
    const IS_Status_A = pageStatus === IPageStatus.statusA;
    const IS_Status_B = pageStatus === IPageStatus.statusB;
    return (
        <div className="ecoflow-wave-3-page">
            {IS_Status_A ? <BannerA /> : <BannerB />}
            <div className="range1">
                <ListA1 />
                {IS_Status_A && <SectionA2 />}
            </div>

            <Animation1 />
            <ListB />
            <SectionB />

            <div className="range4">
                <BlackA />
                <ListA2 />
            </div>
            <div className="range5">
                <FaqA />
            </div>
            <div className="range6">
                <SectionC />
            </div>
            <SectionD />
            {/* {IS_Status_B ? <UserListA /> : <EcoSpace />} */}
            <EcoSpace />
            <Animation3D />
            <CompareA />
            <WhatInBoxA />
            {/* {IS_Status_B && <AccessoriesA />} */}
            <FooterTcA />
            <PageNavLeft
                triggerElement=".ecoflow-wave-3-page"
                steps={[
                    { text: t('item1'), href: '#ListA1' },
                    { text: t('item2'), href: '#wave3-D-title' },
                    { text: t('item3'), href: '#SectionB' },
                    { text: t('item4'), href: '#BlackA' },
                    { text: t('item5'), href: '#FaqA' },
                    { text: t('item6'), href: '#SectionD' },
                ]}
                triggerElements={[
                    { selectors: '#SectionB', theme: Theme.black },
                    { selectors: '#range2', theme: Theme.black },
                    { selectors: '#range3', theme: Theme.white },
                    { selectors: '#ListB', theme: Theme.black },
                    { selectors: '#BlackA', theme: Theme.white },
                    { selectors: '#ListA2', theme: Theme.white },
                    { selectors: '#FaqA', theme: Theme.black },
                ]}
            />
        </div>
    );
}
